import React from 'react';
import { Container, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ApplicationListTable from 'src/ui-component/ApplicationListTable/Index';
import Breadcrumb from 'src/ui-component/Breadcrumb';

const ApplicationList: React.FC = () => {
  const location = useLocation();
  const isDraft = location.pathname.split('/').pop() === 'draft-application';
  const columns = [
    'Application Number',
    'Company Name',
    'Applicant Name',
    'Last Activity Date',
    'Status',
    'Actions'
  ];

  return (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Clerk Solicitor'}
        PageTitle={`${isDraft ? 'Draft' : 'All'} Applications`}
      />

      <Box mt={2}>
        <ApplicationListTable columns={columns} isDraft={isDraft} />
      </Box>
    </Container>
  );
};

export default ApplicationList;
